import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import styles from "./Header.module.css";
import data from "../data/data.json";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export default function Header() {
  // 현재 URL 경로 가져와서 활성화된 메뉴 구분
  const location = useLocation();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [atMain, setAtMain] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedDepth1, setSelectedDepth1] = useState("");

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setAtMain(location.pathname === "/");
  }, [location.pathname]);

  return (
    <>
      <header
        className={cx("header", {
          main: atMain,
          sub: !atMain,
          scrolled: scrollPosition > 0,
          open: isOpen,
        })}
      >
        <div className={cx("wrapper")}>
          <h1>
            <Link to="/" onClick={() => setIsOpen(false)}>
              으뜸손해사정
            </Link>
          </h1>

          <nav className={cx("gnb")}>
            <h2 onClick={() => setIsOpen(!isOpen)}>메뉴열기</h2>
            <ul className={cx("depth1")}>
              {data.category.map((category) => (
                <li
                  key={category.path}
                  className={cx("depth1Item", {
                    selected: selectedDepth1 === category.path,
                  })}
                >
                  <NavLink
                    to={`/${category.path}`}
                    className={cx({
                      activeLink: location.pathname === `/${category.path}`,
                    })}
                    onClick={(e) => {
                      if (isOpen) {
                        // 하위 메뉴(children)가 있는 경우
                        if (category.children && category.children.length > 0) {
                          e.preventDefault(); // 이동 방지하고 하위 메뉴만 보여줌
                          setSelectedDepth1(
                            selectedDepth1 === category.path
                              ? ""
                              : category.path
                          );
                        } else {
                          // 하위 메뉴가 없는 경우: 바로 이동하고 메뉴 닫기
                          setIsOpen(false);
                        }
                      }
                    }}
                  >
                    {category.label}
                  </NavLink>
                  <div
                    className={cx("highlight", {
                      show:
                        !atMain &&
                        location.pathname.includes(`/${category.path}`),
                    })}
                  ></div>

                  {category.children && (
                    <ul className={cx("depth2")}>
                      <div className={cx("depth2Inner")}>
                        {category.children.map((sub) => (
                          <li key={sub.path} className={cx("depth2Item")}>
                            <Link
                              to={`/${category.path}/${sub.path}`}
                              onClick={() => setIsOpen(false)} // 소분류 클릭 시 메뉴 닫기
                            >
                              {sub.label}
                            </Link>
                          </li>
                        ))}
                      </div>
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
}
